import React from "react";
import { List, Tag, Typography, Empty } from "antd";
import { Link } from "react-router-dom";

import { DELIVERY_STATUS_COLORS, formatCLP } from "../../utils/routeMonitoring";

const { Text } = Typography;

// Compact list of orders for one delivery-status bucket inside a DriverRouteCard.
const OrderStatusList = ({ orders, deliveryStatusByOrder }) => {
  if (orders.length === 0) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Sin pedidos" />;
  }

  return (
    <List
      size="small"
      dataSource={orders}
      renderItem={(order) => {
        const status = deliveryStatusByOrder.get(order.order_id);
        return (
          <List.Item style={{ padding: 0 }}>
            {/* Real link (not a div + onClick) so right-click offers "open in
                new tab", and target="_blank" makes that the default too. */}
            <Link
              to={`/orders/${order.order_id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit" }}
              className="flex justify-between items-center w-full gap-2 px-4 py-2 hover:bg-gray-50"
            >
              <div className="flex items-center gap-2 min-w-0">
                <Tag className="font-mono" color={DELIVERY_STATUS_COLORS[status]}>
                  {order.daily_id}
                </Tag>
                <div className="min-w-0">
                  <div className="text-sm font-medium truncate flex items-center gap-1">
                    {order.name}
                    {status === "Parcialmente entregado" && (
                      <Tag color="gold" style={{ marginRight: 0, fontSize: 10, lineHeight: "16px" }}>
                        Parcial
                      </Tag>
                    )}
                  </div>
                  {order.city && (
                    <Text type="secondary" className="text-xs">
                      {order.city}
                    </Text>
                  )}
                </div>
              </div>
              <Text strong className="whitespace-nowrap">
                {formatCLP(order.amount)}
              </Text>
            </Link>
          </List.Item>
        );
      }}
    />
  );
};

export default OrderStatusList;
